import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
// import Footer from './Footer';
import SideBar from "./SideBar";

function Layout() {
  return (
    <>
      <Header />
      <div style={{ display: "flex" }}>
        <SideBar />
        <Outlet />
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Layout;
